import React from 'react';
import Educators from '../../../pages/sites/NetworkSite/Educators';
import Partners from '../../../pages/sites/NetworkSite/Partners';
import Networks from '../../../pages/sites/NetworkSite/Networks';
import District from '../../../pages/sites/NetworkSite/District';
import Projects from '../../../pages/sites/NetworkSite/Projects';

export default function Header(props) {
  const { site } = props;

  return (
    <div className="flex flex-col space-y-6">
      <div className="space-y-2">
        <div className="flex space-x-4">
          <div className="text-sm text-gray-500">
            Site
          </div>
        </div>
        <div className="text-3xl font-bold text-cs-gray-700">
          {site.data.name}
        </div>
        <div className="text-cs-gray-500">
          {site.data.addressLine1}, {site.data.city}, {site.data.state}
        </div>
        <div className="flex justify-between">
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            <Educators site={site} />
            <Partners site={site} />
            <Networks site={site} />
            <District site={site} />
          </div>
          <Projects site={site}/>
        </div>
      </div>
    </div>
  );
};
